// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IyTtZrMSEwAPZJE0595B{flex:0 auto;min-width:74px;max-width:110px;margin-right:28px;font-size:13px;font-weight:500;line-height:16px}.lvr9V1RETX4kYoErMNlM{flex:1;gap:6px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IyTtZrMSEwAPZJE0595B`,
	"actionsWrap": `lvr9V1RETX4kYoErMNlM`
};
export default ___CSS_LOADER_EXPORT___;
